import { Widget,DataWrapper,convertToArray } from "./Widgets";
import data from './DefaultJson.json';
import $ from "jquery";
import { CT_VALIDATION_MESSAGE, STUDY_DOWNLOAD_OPTIONS } from "../../../constants/Constants";

var UIHelperModule = null;
var treeHelper = null;
var submittedValuesJson = null;
var tree = null;
let leafNodesList = null;
var CTBrainId;

export const UIHelperFactory = (templateName) => {
    const getHelper = () => (templateName === 'CT Brain') ? CTBrainUIHelper() : null;
    return {
        getHelper
    };
}


const CTBrainUIHelper = () => {
	console.log("Calling CTBrainUIHelper");
    const getTemplateName = () => 'CT Brain';
    const getTree = () => TreeHelper(getTemplateName()).createTree();

    const getTreeTraversed = () => TreeHelper(getTemplateName()).traverseTree();

    const submitSelections = function () {
        let nodesList = treeHelper.getTreeTraversed();
        let submitMap = new Map();
        nodesList = nodesList.reverse();
        for (let k = 0; k < nodesList.length; k++) {

            let node = nodesList[k];
            let selections = [];
            let nodevalue = node.getNodeValue();

            if (nodevalue !== null) {
                let widget = Widget(nodevalue.getNodeWidgetId(), nodevalue.getNodeWidgetType(), nodevalue.getNodeWidgetDataType(), nodevalue.getNodeWidgetDataFormat());
                selections = widget.getWidgetValue(widget.getWidgetId(), widget.getWidgetType());
				
            } else {
                if (!checkIfChildIsSelected(node) && (k !== ((nodesList.length) - 1))) {
                    nodevalue = NodeValue(Widget('', 0, DataWrapper(0, '')));
                    selections.push("normal");
                } else {
                    if (k === ((nodesList.length) - 1)) {
                        console.log(nodesList[k].getNodeName())
                        nodevalue = NodeValue(Widget('report-type', widgetTypeMap.get('Radio-button'), DataWrapper(1, '')));
                        let widget = Widget(nodevalue.getNodeWidgetId(), nodevalue.getNodeWidgetType(), nodevalue.getNodeWidgetDataType(), nodevalue.getNodeWidgetDataFormat());
                        selections = widget.getWidgetValue(widget.getWidgetId(), widget.getWidgetType());
                    } else {
                        continue;
                    }
                }

            }
            if (selections !== null && Array.isArray(selections) && selections.length) {
                let flag = false;
				if((node.getNodeName() === 'Midline-Shift-Bleed' || node.getNodeName() === 'Midline-Shift-Infarcts') && (selections.includes(undefined))){
					if(selections.includes(undefined)){
						nodevalue.populateValues('normal');
					}
					flag = true;
				}
				else
				{
					 for (let a = 0; a < selections.length; a++) {
                    if (selections[a] !== null && selections[a] != "" && selections[a] !== undefined) {
                        nodevalue.populateValues(selections[a]);
                        flag = true;
                    }
                }
				}
                if (flag) {
                    node.setVisitedFlag(true);
                    addToSubmitMap(node, nodevalue, submitMap);
                }
            }
        }
        return submitMap;
    };

    return {
        getTemplateName,
        getTree,
        getTreeTraversed,
        submitSelections
    };

}



const TreeHelper = (rootName) => {
    const createTree = () => {
        let tree = new Tree();
        var root = tree.createNode(rootName, null, null);
        var BleedNode = tree.createNode("Bleed", null, root);
        var BleedRightNode = tree.createNode("Bleed-Right", null, BleedNode);
        var BleedLeftNode = tree.createNode("Bleed-Left", null, BleedNode);
        tree.createNode("Bleed-Right-Small", NodeValue(Widget('multiSelectReportOptions-bleed-right-small', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), BleedRightNode);
        tree.createNode("Bleed-Right-Moderate", NodeValue(Widget('multiSelectReportOptions-bleed-right-moderate', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), BleedRightNode);
        tree.createNode("Bleed-Right-Large", NodeValue(Widget('multiSelectReportOptions-bleed-right-large', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), BleedRightNode);
        var BleedRightCustom = tree.createNode("Bleed-Right-Custom", NodeValue(Widget('multiSelectReportOptions-bleed-right-custom', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), BleedRightNode);
        tree.createNode("Bleed-Left-Small", NodeValue(Widget('multiSelectReportOptions-bleed-left-small', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), BleedLeftNode);
        tree.createNode("Bleed-Left-Moderate", NodeValue(Widget('multiSelectReportOptions-bleed-left-moderate', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), BleedLeftNode);
        tree.createNode("Bleed-Left-Large", NodeValue(Widget('multiSelectReportOptions-bleed-left-large', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), BleedLeftNode);
        var BleedLeftCustom = tree.createNode("Bleed-Left-Custom", NodeValue(Widget('multiSelectReportOptions-bleed-left-custom', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), BleedLeftNode);
        tree.createNode("Bleed-Right-Custom-Height", NodeValue(Widget('heightSpinner', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), BleedRightCustom);
        tree.createNode("Bleed-Right-Custom-Width", NodeValue(Widget('widthSpinner', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), BleedRightCustom);
        tree.createNode("Bleed-Left-Custom-Height", NodeValue(Widget('heightSpinnerleft', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), BleedLeftCustom);
        tree.createNode("Bleed-Left-Custom-Width", NodeValue(Widget('widthSpinnerleft', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), BleedLeftCustom);
        var HemorrhagicContusion = tree.createNode("Hemorrhagic-Contusion", null, BleedNode);
        var HemorrhagicContusionLeft = tree.createNode("Hemorrhagic-Contusion-Left", null, HemorrhagicContusion);
        var HemorrhagicContusionRight = tree.createNode("Hemorrhagic-Contusion-Right", null, HemorrhagicContusion);
        tree.createNode("Hemorrhagic-Contusion-Right-Small", NodeValue(Widget('multiSelectReportOptions-hemorrhagic-contusion-right-small', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), HemorrhagicContusionRight);
        tree.createNode("Hemorrhagic-Contusion-Right-Moderate", NodeValue(Widget('multiSelectReportOptions-hemorrhagic-contusion-right-moderate', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), HemorrhagicContusionRight);
        tree.createNode("Hemorrhagic-Contusion-Right-Large", NodeValue(Widget('multiSelectReportOptions-hemorrhagic-contusion-right-large', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), HemorrhagicContusionRight);
        var HemorrhagicContusionRightCustom = tree.createNode("Hemorrhagic-Contusion-Right-Custom", NodeValue(Widget('multiSelectReportOptions-hemorrhagic-contusion-right-custom', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), HemorrhagicContusionRight);
        tree.createNode("Hemorrhagic-Contusion-Left-Small", NodeValue(Widget('multiSelectReportOptions-hemorrhagic-contusion-left-small', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), HemorrhagicContusionLeft);
        tree.createNode("Hemorrhagic-Contusion-Left-Moderate", NodeValue(Widget('multiSelectReportOptions-hemorrhagic-contusion-left-moderate', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), HemorrhagicContusionLeft);
        tree.createNode("Hemorrhagic-Contusion-Left-Large", NodeValue(Widget('multiSelectReportOptions-hemorrhagic-contusion-left-large', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), HemorrhagicContusionLeft);
        var HemorrhagicContusionLeftCustom = tree.createNode("Hemorrhagic-Contusion-Left-Custom", NodeValue(Widget('multiSelectReportOptions-hemorrhagic-contusion-left-custom', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), HemorrhagicContusionLeft);
        tree.createNode("Hemorrhagic-Contusion-Right-Custom-Height", NodeValue(Widget('heightSpinnerHCR', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), HemorrhagicContusionRightCustom);
        tree.createNode("Hemorrhagic-Contusion-Right-Custom-Width", NodeValue(Widget('widthSpinnerHCR', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), HemorrhagicContusionRightCustom);
        tree.createNode("Hemorrhagic-Contusion-Left-Custom-Height", NodeValue(Widget('heightSpinnerHCL', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), HemorrhagicContusionLeftCustom);
        tree.createNode("Hemorrhagic-Contusion-Left-Custom-Width", NodeValue(Widget('widthSpinnerHCL', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), HemorrhagicContusionLeftCustom);
        var EpiduralHematoma = tree.createNode("Epidural-Hematoma", null, BleedNode);
        var EpiduralHematomaRight = tree.createNode("Epidural-Hematoma-Right", null, EpiduralHematoma);
        var EpiduralHematomaLeft = tree.createNode("Epidural-Hematoma-Left", null, EpiduralHematoma);
        tree.createNode("Epidural-Hematoma-Right-Small", NodeValue(Widget('multiSelectReportOptions-epidural-hematoma-right-small', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), EpiduralHematomaRight);
        tree.createNode("Epidural-Hematoma-Right-Moderate", NodeValue(Widget('multiSelectReportOptions-epidural-hematoma-right-moderate', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), EpiduralHematomaRight);
        tree.createNode("Epidural-Hematoma-Right-Large", NodeValue(Widget('multiSelectReportOptions-epidural-hematoma-right-large', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), EpiduralHematomaRight);
        var EpiduralHematomaRightCustom = tree.createNode("Epidural-Hematoma-Right-Custom", NodeValue(Widget('multiSelectReportOptions-epidural-hematoma-right-custom', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), EpiduralHematomaRight);
        tree.createNode("Epidural-Hematoma-Left-Small", NodeValue(Widget('multiSelectReportOptions-epidural-hematoma-left-small', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), EpiduralHematomaLeft);
        tree.createNode("Epidural-Hematoma-Left-Moderate", NodeValue(Widget('multiSelectReportOptions-epidural-hematoma-left-moderate', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), EpiduralHematomaLeft);
        tree.createNode("Epidural-Hematoma-Left-Large", NodeValue(Widget('multiSelectReportOptions-epidural-hematoma-left-large', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), HemorrhagicContusionLeft);
        var EpiduralHematomaLeftCustom = tree.createNode("Epidural-Hematoma-Left-Custom", NodeValue(Widget('multiSelectReportOptions-epidural-hematoma-left-custom', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), HemorrhagicContusionLeft);
        tree.createNode("Epidural-Hematoma-Right-Custom-Height", NodeValue(Widget('heightSpinnerEHR', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), EpiduralHematomaRightCustom);
        tree.createNode("Epidural-Hematoma-Right-Custom-Width", NodeValue(Widget('widthSpinnerEHR', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), EpiduralHematomaRightCustom);
        tree.createNode("Epidural-Hematoma-Left-Custom-Height", NodeValue(Widget('heightSpinnerEHL', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), EpiduralHematomaLeftCustom);
        tree.createNode("Epidural-Hematoma-Left-Custom-Width", NodeValue(Widget('widthSpinnerEHL', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), EpiduralHematomaLeftCustom);
        var SubduralHematoma = tree.createNode("Subdural-Hematoma", null, BleedNode);
        var SubduralHematomaRight = tree.createNode("Subdural-Hematoma-Right", null, SubduralHematoma);
        var SubduralHematomaLeft = tree.createNode("Subdural-Hematoma-Left", null, SubduralHematoma);
        tree.createNode("Subdural-Hematoma-Right-Small", NodeValue(Widget('multiSelectReportOptions-subdural-hematoma-right-small', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), SubduralHematomaRight);
        tree.createNode("Subdural-Hematoma-Right-Moderate", NodeValue(Widget('multiSelectReportOptions-subdural-hematoma-right-moderate', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), SubduralHematomaRight);
        tree.createNode("Subdural-Hematoma-Right-Large", NodeValue(Widget('multiSelectReportOptions-subdural-hematoma-right-large', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), SubduralHematomaRight);
        var SubduralHematomaRightCustom = tree.createNode("Subdural-Hematoma-Right-Custom", NodeValue(Widget('multiSelectReportOptions-subdural-hematoma-right-custom', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), SubduralHematomaRight);
        tree.createNode("Subdural-Hematoma-Left-Small", NodeValue(Widget('multiSelectReportOptions-subdural-hematoma-left-small', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), SubduralHematomaLeft);
        tree.createNode("Subdural-Hematoma-Left-Moderate", NodeValue(Widget('multiSelectReportOptions-subdural-hematoma-left-moderate', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), SubduralHematomaLeft);
        tree.createNode("Subdural-Hematoma-Left-Large", NodeValue(Widget('multiSelectReportOptions-subdural-hematoma-left-large', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), SubduralHematomaLeft);
        var SubduralHematomaLeftCustom = tree.createNode("Subdural-Hematoma-Left-Custom", NodeValue(Widget('multiSelectReportOptions-subdural-hematoma-left-custom', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), SubduralHematomaLeft);
        tree.createNode("Subdural-Hematoma-Right-Custom-Height", NodeValue(Widget('heightSpinnerSDHR', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), SubduralHematomaRightCustom);
        tree.createNode("Subdural-Hematoma-Right-Custom-Width", NodeValue(Widget('widthSpinnerSDHR', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), SubduralHematomaRightCustom);
        tree.createNode("Subdural-Hematoma-Left-Custom-Height", NodeValue(Widget('heightSpinnerSDHL', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), SubduralHematomaLeftCustom);
        tree.createNode("Subdural-Hematoma-Left-Custom-Width", NodeValue(Widget('widthSpinnerSDHL', widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), SubduralHematomaLeftCustom);
        tree.createNode("Midline-Shift-Bleed", NodeValue(Widget('midline-shift', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), BleedNode);
        tree.createNode("Perilesional-Edema", NodeValue(Widget('perilesional-edema', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), BleedNode);
        tree.createNode("Mass-Effect-Bleed", NodeValue(Widget('mass-effect', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), BleedNode);
        tree.createNode("Sulcal-Effacement-Bleed", NodeValue(Widget('sulcal-effacement', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), BleedNode);
        var VentricularExtensionAndDilation = tree.createNode("Ventricular-Extension-And-Dilation", null, BleedNode);
        var VentricularExtensionWithoutDilation = tree.createNode("Ventricular-Extension-Without-Dilation", null, BleedNode);
        tree.createNode("Ventricular-Extension-And-Dilation-Ipsilateral", NodeValue(Widget('ventricular-extension-and-dilation-ipsilateral', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), VentricularExtensionAndDilation);
        tree.createNode("Ventricular-Extension-And-Dilation-Ipsilateral-And-Contralateral", NodeValue(Widget('ventricular-extension-and-dilation-ipsilateral-and-contralateral', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), VentricularExtensionAndDilation);
        tree.createNode("Ventricular-Extension-Without-Dilation-Ipsilateral", NodeValue(Widget('ventricular-extension-without-dilation-ipsilateral', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), VentricularExtensionWithoutDilation);
        tree.createNode("Ventricular-Extension-Without-Dilation-Ipsilateral-And-Contralateral", NodeValue(Widget('ventricular-extension-without-dilation-ipsilateral-and-contralateral', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), VentricularExtensionWithoutDilation);
        var Infarcts = tree.createNode("Infarcts", null, root);
        var InfarctsRight = tree.createNode("Infarcts-Right", null, Infarcts)
        var InfarctsLeft = tree.createNode("Infarcts-Left", null, Infarcts)
        tree.createNode("Focal-Right", NodeValue(Widget('multiSelectReportOptions-infarcts-right-focal', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsRight);
        tree.createNode("Multiple-Lacunar-Right", NodeValue(Widget('multiSelectReportOptions-infarcts-right-multiple-lacunar', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsRight);
        tree.createNode("Focal-Left", NodeValue(Widget('multiSelectReportOptions-infarcts-left-focal', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsLeft);
        tree.createNode("Multiple-Lacunar-Left", NodeValue(Widget('multiSelectReportOptions-infarcts-left-multiple-lacunar', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsLeft);
        tree.createNode("Acute-Right", NodeValue(Widget('multiSelectReportOptions-infarcts-right-acute', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsRight);
        tree.createNode("Acute-Left", NodeValue(Widget('multiSelectReportOptions-infarcts-left-acute', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsLeft);
        tree.createNode("Subacute-Right", NodeValue(Widget('multiSelectReportOptions-infarcts-right-subacute', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsRight);
        tree.createNode("Subacute-Left", NodeValue(Widget('multiSelectReportOptions-infarcts-left-subacute', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsLeft);
        tree.createNode("Chronic-With-Areas-Of-Gliosis-Right", NodeValue(Widget('multiSelectReportOptions-infarcts-right-chronic-gliosis', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsRight);
        tree.createNode("Chronic-With-Areas-Of-Gliosis-Left", NodeValue(Widget('multiSelectReportOptions-infarcts-left-chronic-gliosis', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsLeft);
        tree.createNode("Hypodense-Wedge-Shaped-Small-Right", NodeValue(Widget('multiSelectReportOptions-infarcts-right-hypodense-wedge-shaped-small', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsRight);
        tree.createNode("Hypodense-Wedge-Shaped-Small-Left", NodeValue(Widget('multiSelectReportOptions-infarcts-left-hypodense-wedge-shaped-small', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsLeft);
        tree.createNode("Hypodense-Wedge-Shaped-Large-Right", NodeValue(Widget('multiSelectReportOptions-infarcts-right-hypodense-wedge-shaped-large', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsRight);
        tree.createNode("Hypodense-Wedge-Shaped-Large-Left", NodeValue(Widget('multiSelectReportOptions-infarcts-left-hypodense-wedge-shaped-large', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), InfarctsLeft);
        tree.createNode("Sulcal-Effacement-Infarcts", NodeValue(Widget('sulcal-effacements-infarcts', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Infarcts);
        tree.createNode("Mass-Effect-Infarcts", NodeValue(Widget('mass-effect-infarcts', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Infarcts);
        tree.createNode("Midline-Shift-Infarcts", NodeValue(Widget('midline-shift-infarcts', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Infarcts);
        var Atrophy = tree.createNode("Atrophy", null, root);
        tree.createNode("Normal-Or-GCA", NodeValue(Widget('gca', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Atrophy);
        tree.createNode("InconsistentGCA-NPH-Communicating-Hydrocephalus", NodeValue(Widget('nph', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Atrophy);
        tree.createNode("Non-Communicating-Hydrocephalus-GCE", NodeValue(Widget('gce', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Atrophy);
        var Others = tree.createNode("Others", null, root);
        tree.createNode("Normal-Midline-Others", NodeValue(Widget('others-midline', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Others);
        tree.createNode("Ventricular-Structures-Others", NodeValue(Widget('others-ventricular', widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Others);
        tree.createNode("Neurodegenerative-Calcification-Others", NodeValue(Widget('multiSelectReportOptions-neuro-degenerative-calcification', widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), Others);
        tree.createNode("Midline-Custom-Others", NodeValue(Widget("others-custom-midline", widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Others);
        tree.createNode("Midline-Shift-Custom-Others", NodeValue(Widget("others-midline-shift-measure", widgetTypeMap.get('Textbox'), DataWrapper(dataTypeMap.get('Double'), ''))), Others);
        tree.createNode("Mucosal-Thickening", NodeValue(Widget("multiSelectReportOptions-mucosal-thickening", widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), Others);
        tree.createNode("Fluid-levels-Others", NodeValue(Widget("multiSelectReportOptions-fluid-levels", widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), Others);
        tree.createNode("Polyp-Others", NodeValue(Widget("multiSelectReportOptions-others-polyp", widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), Others);
        tree.createNode("Osseous-Skull-Others", NodeValue(Widget("others-osseous-skull", widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Others);
        tree.createNode("Osseous-Calvarium-Others", NodeValue(Widget("others-osseous-calvarium", widgetTypeMap.get('Radio-button'), DataWrapper(dataTypeMap.get('String'), ''))), Others);
        tree.createNode("Fracture", NodeValue(Widget("multiSelectReportOptions-others-fracture", widgetTypeMap.get('Multi-select-dropdown'), DataWrapper(dataTypeMap.get('String'), ''))), Others);
        return tree;
    }

    const traverseTree = () => {
        return depthFirstSearchTraversal();
    }

    return {
        createTree,
        traverseTree
    };

}

export const onShowEvent = () => {
    console.log("Calling onShowEvent");
    UIHelperModule = UIHelperFactory("CT Brain");
    treeHelper = UIHelperModule.getHelper();
    
    
    applyServerDefaults(data.default_json,treeHelper);
    console.log(data.default_json);
    
    registerMultiSelectEvent();
    
    // if (serverDefaultsJson !== "") {
    //     applyServerDefaults(JSON.parse(serverDefaultsJson));
    // }
}

export const onRegenerate = () => {
        console.log("onRegenerated called");
        let SubmitValues = treeHelper.submitSelections();
    console.log(SubmitValues);
        var myJSON = {}
        myJSON.submitValues = mapToObj(SubmitValues);
        var selectionsString = JSON.stringify(myJSON.submitValues);
    
        submittedValuesJson = JSON.stringify(myJSON.submitValues);
        console.log(submittedValuesJson);
    
        let validationResult = validateCTBrainFindings();
        if(validationResult != null)
        {
            // $("#universal_modal").modal("hide");
           // alert(validationResult.message);
            return {error:true, message: validationResult.message};
        }
        
        //event.preventDefault();
        //event.stopPropagation();
    
        const ctBrainForm = $("form[name='form_ct_brain']");
        let ctBrainData = ctBrainForm.serializeArray();
        ctBrainData.push({
            name: 'values',
            value: selectionsString
        })
    
        console.log("Final data");
        console.log(ctBrainData);
        return ctBrainData;
}

function depthFirstSearchTraversal() {
    var stack = Stack();
    let nodesList = new Array();
    let root = treeHelper.getTree().root;
    let currentNode = null;
    stack.push(root);

    while (!stack.isEmpty()) {
        currentNode = stack.pop();
        nodesList.push(currentNode);
        // console.log("Current node: " + currentNode.getNodeName())
        if (Array.isArray(currentNode.getChildren()) && currentNode.getChildren().length) {
            for (let i = 0; i < currentNode.getChildren().length; i++) {
                stack.push(currentNode.getChildren()[i]);
            }
        }
    }
    return nodesList;

}

function checkIfChildIsSelected(node) {
    if (Array.isArray(node.getChildren()) && node.getChildren().length) {
        for (let m = 0; m < node.getChildren().length; m++) {
            if (node.getChildren()[m].getVisitedFlag() === true) {
                return true;
            }
        }
    }
    return false;
}

function addToSubmitMap(node, nodeVal, submitMap) {
    submitMap.set(node.getNodeName(), {
        "value": nodeVal.getNodeSelectedvalues(),
        "dataType": {
            "dataTypeFormat": nodeVal.getNodeWidgetDataFormat(),
            "dataType": nodeVal.getNodeWidgetDataType()
        }
    });
}

export function applyServerDefaults(jsonData,treeHelper) {

    for (const [key, value] of Object.entries(jsonData)) {
        let selections;
        let node = treeHelper.getTree().getNodeMap().get(key);
        let defaultSelections = value['value'];
        let nodevalue = node.getNodeValue();
        if (nodevalue) {
            let widget = Widget(nodevalue.getNodeWidgetId(), nodevalue.getNodeWidgetType(), nodevalue.getNodeWidgetDataType(), nodevalue.getNodeWidgetDataFormat());
            let element = widget.setWidgetValue(widget.getWidgetId(), widget.getWidgetType(), defaultSelections);
            //console.log(node.getNodeName() + " default selections : " + defaultSelections + " node value : " + widget.getWidgetId() + "  " + element);
        }
        if (key == 'CT Brain') {
            nodevalue = NodeValue(Widget('report-type', widgetTypeMap.get('Radio-button'), DataWrapper(1, '')));
            let widget = Widget(nodevalue.getNodeWidgetId(), nodevalue.getNodeWidgetType(), nodevalue.getNodeWidgetDataType(), nodevalue.getNodeWidgetDataFormat());
            selections = widget.setWidgetValue(widget.getWidgetId(), widget.getWidgetType(), defaultSelections);
        }
    }
}


const Node = (nodeName, nodeValue, parent) => {
    let children = new Array();
	let visitedFlag = false;
    const getNodeName = () => nodeName;
    const getNodeValue = () => nodeValue;
    const getParent = () => parent;

    const getChildren = () => children;
    const addChild = function (child) {
        children.push(child);
    }

    const getVisitedFlag = () => visitedFlag;
    const setVisitedFlag = function (visited) {
        visitedFlag = visited;
    }
    return {
        getNodeName,
        getNodeValue,
        getParent,
        getChildren,
        addChild,
        getVisitedFlag,
        setVisitedFlag
    };
}

const NodeValue = (Widget) => {
    let values = new Array();
    const getNodeWidgetId = () => Widget.getWidgetId();
    const getNodeWidgetType = () => Widget.getWidgetType();
    const getNodeWidgetDataType = () => Widget.getWidgetDataType();
    const getNodeWidgetDataFormat = () => Widget.getWidgetDataFormat();
    //TODO
    const getValues = "";
    // const getValues = () => widget.getWidgetValues(Widget.getWidgetId(), Widget.getWidgetType());
    const populateValues = function (value) {
        values.push(value);
    }

    const getNodeSelectedvalues = () => values;
    return {
        getNodeWidgetId,
        getNodeWidgetType,
        getNodeWidgetDataType,
        getValues,
        populateValues,
        getNodeSelectedvalues,
        getNodeWidgetDataFormat
    };
}


class Tree {

    constructor() {
        this.root = null;
        this.nodeMap = new Map();
    }

    createNode(nodeName, nodeValue, parent) {
        const node = Node(nodeName, nodeValue, parent);
        if (parent === null) {
            this.root = node;
            this.nodeMap.set(nodeName, node);
        } else {
            this.nodeMap.set(nodeName, node);
            parent.addChild(node);

        }
        return node;

    }

    getNodeMap() {
        return this.nodeMap;
    }

}

var dataTypeMap = new Map([
    ["Hidden", "0"],
    ["String", "1"],
    ["Double", "2"],
    ["Date", "3"],
    ["Long", "4"]
]);


var widgetTypeMap = new Map([
    ["Hidden", "0"],
    ["Textbox", "1"],
    ["TextArea", "2"],
    ["Radio-button", "3"],
    ["Check-box", "4"],
    ["Single-select-dropdown", "5"],
    ["Multi-select-dropdown", "6"]

]);

export function registerMultiSelectEvent() {

    var multiSelectWidgetIdList = ["multiSelectReportOptions-bleed-right-small", "multiSelectReportOptions-bleed-right-moderate",
        "multiSelectReportOptions-bleed-right-large", "multiSelectReportOptions-bleed-right-custom", "multiSelectReportOptions-bleed-left-small",
        "multiSelectReportOptions-bleed-left-moderate", "multiSelectReportOptions-bleed-left-large", "multiSelectReportOptions-bleed-left-custom",
        "multiSelectReportOptions-hemorrhagic-contusion-right-small", "multiSelectReportOptions-hemorrhagic-contusion-right-moderate",
        "multiSelectReportOptions-hemorrhagic-contusion-right-large", "multiSelectReportOptions-hemorrhagic-contusion-right-custom",
        "multiSelectReportOptions-hemorrhagic-contusion-left-small", "multiSelectReportOptions-hemorrhagic-contusion-left-moderate",
        "multiSelectReportOptions-hemorrhagic-contusion-left-large", "multiSelectReportOptions-hemorrhagic-contusion-left-custom",
        "multiSelectReportOptions-epidural-hematoma-right-small", "multiSelectReportOptions-epidural-hematoma-right-moderate",
        "multiSelectReportOptions-epidural-hematoma-right-large", "multiSelectReportOptions-epidural-hematoma-right-custom",
        "multiSelectReportOptions-epidural-hematoma-left-small", "multiSelectReportOptions-epidural-hematoma-left-moderate",
        "multiSelectReportOptions-epidural-hematoma-left-large", "multiSelectReportOptions-epidural-hematoma-left-custom",
        "multiSelectReportOptions-subdural-hematoma-right-small", "multiSelectReportOptions-subdural-hematoma-right-moderate",
        "multiSelectReportOptions-subdural-hematoma-right-large", "multiSelectReportOptions-subdural-hematoma-right-custom",
        "multiSelectReportOptions-subdural-hematoma-left-small", "multiSelectReportOptions-subdural-hematoma-left-moderate",
        "multiSelectReportOptions-subdural-hematoma-left-large", "multiSelectReportOptions-subdural-hematoma-left-custom",
        "multiSelectReportOptions-infarcts-right-focal", "multiSelectReportOptions-infarcts-right-multiple-lacunar", "multiSelectReportOptions-infarcts-right-acute",
        "multiSelectReportOptions-infarcts-right-subacute", "multiSelectReportOptions-infarcts-right-chronic-gliosis",
        "multiSelectReportOptions-infarcts-right-hypodense-wedge-shaped-small", "multiSelectReportOptions-infarcts-right-hypodense-wedge-shaped-large",
        "multiSelectReportOptions-infarcts-left-focal", "multiSelectReportOptions-infarcts-left-multiple-lacunar", "multiSelectReportOptions-infarcts-left-acute",
        "multiSelectReportOptions-infarcts-left-subacute", "multiSelectReportOptions-infarcts-left-chronic-gliosis",
        "multiSelectReportOptions-infarcts-left-hypodense-wedge-shaped-small", "multiSelectReportOptions-infarcts-left-hypodense-wedge-shaped-large",
        "multiSelectReportOptions-neuro-degenerative-calcification", "multiSelectReportOptions-mucosal-thickening",
        "multiSelectReportOptions-fluid-levels", "multiSelectReportOptions-others-polyp", "multiSelectReportOptions-others-fracture"
    ];

    for (let i = 0; i < multiSelectWidgetIdList.length; i++) {
        $("#" + multiSelectWidgetIdList[i] + " option").mousedown(customMultiSelect);
    }

}

function customMultiSelect(e) {
    e.preventDefault();
    var originalScrollTop = $(this).parent().scrollTop();
    console.log(originalScrollTop);
    $(this).prop('selected', $(this).prop('selected') ? false : true);
    var self = this;
    $(this).parent().focus();
    setTimeout(function () {
        $(self).parent().scrollTop(originalScrollTop);
    }, 0);

    return false;
}

const Stack = () => {
    let stackArray = new Array();
    let top = -1;
    const peek = () => top;
    const getTopElement = () => stackArray[top];
    const isEmpty = function () {
        return stackArray.length == 0;
    }
    const push = function (element) {
        stackArray.push(element);
        ++top;
    }
    const pop = function () {
        if (top > 0 || top === 0) {
            top--;
            return stackArray.pop();
        }
    }

    return {
        peek,
        getTopElement,
        isEmpty,
        push,
        pop
    }

}

function mapToObj(map) {
    var obj = {}
    map.forEach(function (v, k) {
        obj[k] = v
    })
    return obj
}

function validateCTBrainFindings(){
	let res;
	
	res = validateBleedCustomResults();
	if(res !== null){
		return res;
	}
	 res = validateHemorhagicContusionCustomResults();
	if(res !== null){
		return res;
	}
	 res = validateEpiduralHematomaCustomResults();
	if(res !== null){
		return res;
	}
	 res = validateSubduralHematomaCustomResults();
	if(res !== null){
		return res;
	}
	return null;
	
}

function validateBleedCustomResults(){
	
	let widgetVal; 
	let heightValue;
	let widthValue;
	
	widgetVal = $('#multiSelectReportOptions-bleed-right-custom').val();
	heightValue = $('#heightSpinner').val();
    widthValue = $('#widthSpinner').val();
	
	 if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") && (widthValue == null || widthValue == undefined || widthValue == "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorBleedRightDimensions }
	}
	 else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") ){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorBleedRightHeight }
	}
	else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (widthValue == null || widthValue == undefined || widthValue == "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorBleedRightWidth }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") && (widthValue != null && widthValue != undefined && widthValue != "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") ){
		return {error :1, message : "Please select an option for the provided dimensions and also enter the width." }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (widthValue != null && widthValue != undefined && widthValue != "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndHeightFromDimension }
	}
	
	
	
	widgetVal = $('#multiSelectReportOptions-bleed-left-custom').val();
	heightValue = $('#heightSpinnerleft').val();
    widthValue = $('#widthSpinnerleft').val();
	
	 if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") && (widthValue == null || widthValue == undefined || widthValue == "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorBleedLeftDimensions }
	}
	 else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") ){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorBleedLeftHeight }
	}
	else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (widthValue == null || widthValue == undefined || widthValue == "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorBleedLeftWidth }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") && (widthValue != null && widthValue != undefined && widthValue != "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") ){
		return {error :1, message : "Please select an option for the provided dimensions and also enter the width." }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (widthValue != null && widthValue != undefined && widthValue != "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndHeightFromDimension }
	}
	return null;
}


function validateHemorhagicContusionCustomResults(){
	let widgetVal; 
	let heightValue;
	let widthValue;
	
	widgetVal = $('#multiSelectReportOptions-hemorrhagic-contusion-right-custom').val();
	heightValue = $('#heightSpinnerHCR').val();
    widthValue = $('#widthSpinnerHCR').val();
	
	 if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") && (widthValue == null || widthValue == undefined || widthValue == "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorHemorrhagicRightDimensions }
	}
	 else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") ){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorHemorrhagicRightHeight }
	}
	else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (widthValue == null || widthValue == undefined || widthValue == "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorHemorrhagicRightWidth }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") && (widthValue != null && widthValue != undefined && widthValue != "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension}
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") ){
		return {error :1, message : "Please select an option for the provided dimensions and also enter the width." }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (widthValue != null && widthValue != undefined && widthValue != "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndHeightFromDimension }
	}
	
	
	
	widgetVal = $('#multiSelectReportOptions-hemorrhagic-contusion-left-custom').val();
	heightValue = $('#heightSpinnerHCL').val();
    widthValue = $('#widthSpinnerHCL').val();
	
	 if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") && (widthValue == null || widthValue == undefined || widthValue == "")){
		return {error :1, message :CT_VALIDATION_MESSAGE._iMessageCtBrainErrorHemorrhagicLeftDimensions}
	}
	 else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") ){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorHemorrhagicLeftHeight }
	}
	else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (widthValue == null || widthValue == undefined || widthValue == "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorHemorrhagicLeftWidth }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") && (widthValue != null && widthValue != undefined && widthValue != "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") ){
		return {error :1, message : "Please select an option for the provided dimensions and also enter the width." }
	}
	else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (widthValue != null && widthValue != undefined && widthValue != "")){
		return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndHeightFromDimension }
	}
	return null;
}

function validateEpiduralHematomaCustomResults(){
    let widgetVal; 
        let heightValue;
        let widthValue;
        
        widgetVal = $('#multiSelectReportOptions-epidural-hematoma-right-custom').val();
        heightValue = $('#heightSpinnerEHR').val();
        widthValue = $('#widthSpinnerEHR').val();
        
         if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") && (widthValue == null || widthValue == undefined || widthValue == "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorEpiduralRightDimensions }
        }
         else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") ){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorEpiduralRightHeight }
        }
        else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (widthValue == null || widthValue == undefined || widthValue == "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorEpiduralRightWidth }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") && (widthValue != null && widthValue != undefined && widthValue != "")){
            return {error :1, message :CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") ){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (widthValue != null && widthValue != undefined && widthValue != "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndHeightFromDimension }
        }
        
        widgetVal = $('#multiSelectReportOptions-epidural-hematoma-left-custom').val();
        heightValue = $('#heightSpinnerEHL').val();
        widthValue = $('#widthSpinnerEHL').val();
        
         if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") && (widthValue == null || widthValue == undefined || widthValue == "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorEpiduralLeftDimensions }
        }
         else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") ){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorEpiduralLeftHeight }
        }
        else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (widthValue == null || widthValue == undefined || widthValue == "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorEpiduralLeftWidth }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") && (widthValue != null && widthValue != undefined && widthValue != "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") ){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (widthValue != null && widthValue != undefined && widthValue != "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndHeightFromDimension }
        }
        return null;
    }
    
    function validateSubduralHematomaCustomResults(){
        let widgetVal; 
        let heightValue;
        let widthValue;
        
        widgetVal = $('#multiSelectReportOptions-subdural-hematoma-right-custom').val();
        heightValue = $('#heightSpinnerSDHR').val();
        widthValue = $('#widthSpinnerSDHR').val();
        
         if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") && (widthValue == null || widthValue == undefined || widthValue == "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorSubduralRightDimensions }
        }
         else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") ){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorSubduralRightHeight }
        }
        else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (widthValue == null || widthValue == undefined || widthValue == "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorSubduralRightWidth }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") && (widthValue != null && widthValue != undefined && widthValue != "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") ){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (widthValue != null && widthValue != undefined && widthValue != "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndHeightFromDimension }
        }
            
        widgetVal = $('#multiSelectReportOptions-subdural-hematoma-left-custom').val();
        heightValue = $('#heightSpinnerSDHL').val();
        widthValue = $('#widthSpinnerSDHL').val();
        
         if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") && (widthValue == null || widthValue == undefined || widthValue == "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorSubduralLeftDimensions}
        }
         else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (heightValue == null || heightValue == undefined || heightValue == "") ){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorSubduralLeftHeight}
        }
        else if((widgetVal != null && widgetVal != undefined && widgetVal != "") && (widthValue == null || widthValue == undefined || widthValue == "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainErrorSubduralLeftWidth }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") && (widthValue != null && widthValue != undefined && widthValue != "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (heightValue != null && heightValue != undefined && heightValue != "") ){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndWidthFromDimension }
        }
        else if((widgetVal == null || widgetVal == undefined || widgetVal == "") && (widthValue != null && widthValue != undefined && widthValue != "")){
            return {error :1, message : CT_VALIDATION_MESSAGE._iMessageCtBrainSelectOptionAndHeightFromDimension }
        }
        return null;
    }